import Phaser from 'phaser';

export class PowerupRenderer {
  private sceneRef: Phaser.Scene;

  constructor(scene: Phaser.Scene) {
    this.sceneRef = scene;
  }

  spawnFlash(x: number, y: number, color: number = 0xffffff): void {
    const flash = this.sceneRef.add.rectangle(x, y, 8, 8, color, 0.5).setScrollFactor(0);
    this.sceneRef.add.tween({
      targets: flash,
      duration: 120,
      alpha: 0,
      onComplete: () => flash.destroy(),
    });
  }

  spawnParticles(x: number, y: number, count: number, color: number = 0xffffff): void {
    for (let i = 0; i < count; i++) {
      const angle = (Math.PI * 2 * i) / count;
      const speed = 2 + Math.random() * 3;
      const particle = this.sceneRef.add.rectangle(x, y, 4, 4, color).setScrollFactor(0);
      this.sceneRef.add.tween({
        targets: particle,
        x: x + Math.cos(angle) * speed * 30,
        y: y + Math.sin(angle) * speed * 30,
        alpha: 0,
        duration: 300,
        onComplete: () => particle.destroy(),
      });
    }
  }

  spawnFloatingText(x: number, y: number, text: string): void {
    const textObj = this.sceneRef.add.text(x, y, text, {
      fontSize: '12px',
      fontFamily: 'monospace',
      color: '#ffff00',
    }).setOrigin(0.5).setDepth(8);
    this.sceneRef.add.tween({
      targets: textObj,
      y: y - 30,
      alpha: 0,
      duration: 500,
      onComplete: () => textObj.destroy(),
    });
  }

  /** Comic hit phrase shown above the player when an enemy strikes. */
  spawnHitPhrase(x: number, y: number, text: string, duration = 2400): void {
    const textObj = this.sceneRef.add.text(x, y - 20, `¡${text}!`, {
      fontSize: '22px',
      fontFamily: 'Arial Black, Impact, sans-serif',
      color: '#ffff00',
      stroke: '#000000',
      strokeThickness: 4,
      backgroundColor: '#000000cc',
      padding: { x: 8, y: 4 },
      wordWrap: { width: 320 },
      align: 'center',
    }).setOrigin(0.5).setScrollFactor(1).setDepth(9);
    // Pop-in effect
    textObj.setScale(0.3);
    this.sceneRef.add.tween({
      targets: textObj,
      scaleX: 1, scaleY: 1,
      duration: 200,
      ease: 'Back.easeOut',
    });
    this.sceneRef.add.tween({
      targets: textObj,
      y: y - 60,
      alpha: { from: 1, to: 0 },
      ease: 'Quad.easeIn',
      delay: duration - 600,
      duration: 600,
      onComplete: () => textObj.destroy(),
    });
  }
}
